/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(document).ready(function () {
	$(document).on('click', '[data-action="quick-add-to-cart"]', function (e) {
		e.preventDefault();

		var data = {
			quantity: 1,
			id: $(this).parent().find('.SizeSwatch__Radio:checked').attr('data-variant-id')
		};
			
		$.ajax({
			type: 'POST',
			url: '/cart/add.js',
			dataType: 'json',
			data: data,
			success: function (data) {
				
				document.documentElement.dispatchEvent(new CustomEvent('product:added', {
					bubbles: true,
					detail: {
						variant:  $(this).parent().find('.SizeSwatch__Radio:checked').attr('data-variant-id'),
						quantity: 1
					}
				}));
				
			}
		});
	});
	
	$(window).scroll(function() {
		if ($(this).scrollTop() > 300 && !$('.back-to-top').is(':visible')) {
			$('.back-to-top').fadeIn();
		} else if ($(this).scrollTop() < 300 && $('.back-to-top').is(':visible')) {
			$('.back-to-top').hide();
		}
	})
	
	$('.back-to-top').on('click', function (e) {
		e.preventDefault();
		
		$('html, body').stop().animate({
			scrollTop: 0
		}, 500, 'linear');
		return false;
	});
	
	$(window).resize(function () {
				enableZoom();
	});
	enableZoom();
	
		
		function enableZoom () {
			if ($('.image-zoom').length) {
				if ($(window).width() > 767) {
					$('.image-zoom')
						.parent()
						.zoom({
							url: $(this).find('img').attr('data-zoom'),
							magnify: 1
					});
				} else {
					$('.image-zoom').trigger('zoom.destroy')
				}
			}
			setTimeout(function () {
				if ($(window).width() < 1008) {
					$($('.afterpay-paragraph').detach()).appendTo(".for-afterpay-mobile");
				}
			}, 500)
		
		}
		
		$(document).on('click', '.select-size-mobile', function (e) {
			e.preventDefault();
			$(this).next().fadeToggle()
		});
		
		$(document).on('click', '.size-list-item', function (e) {
			e.preventDefault();
			var thisVarId = $(this).attr('data-variant-id');
			var data = {
				quantity: 1,
				id: thisVarId
			};
			$(this).parents('.mobile-sizes__dropdown').fadeOut();
			
			$.ajax({
				type: 'POST',
				url: '/cart/add.js',
				dataType: 'json',
				data: data,
				success: function (data) {
					
					document.documentElement.dispatchEvent(new CustomEvent('product:added', {
						bubbles: true,
						detail: {
							variant:  thisVarId,
							quantity: 1
						}
					}));
					
				}
			});
		})
		
	if (window.location.hash.indexOf('#leave-review') !== -1) {
		$('#shopify-product-reviews').parents('.Collapsible__Inner')
			.css({'visibility': 'visible', 'height': 'auto'})
			.addClass('show-form')
			.prev().attr('aria-expanded', 'true')
		
		setTimeout(function () {
			$('.spr-form').show();
			
			$('html, body').animate({
				scrollTop: $(".spr-form").offset().top - 80
			}, 2000);
		}, 0)
		
	}
	
	$('.alternate-image-slider').flickity({
		prevNextButtons: true,
		pageDots: true,
		adaptiveHeight: true,
		lazyLoad: true,
		draggable: true,
		imagesLoaded: true,
		arrowShape: {"x0": 20, "x1": 60, "y1": 40, "x2": 60, "y2": 35, "x3": 25}
	})
	
	$('.changePasswordCTA').on('click', function (e) {
		e.preventDefault();
		var data = $('#recover_customer_password').serialize();
		
		jQuery.post('/account/recover', data)
			.done(function(data){
				$('#modal-changePassword .recover-error-message').hide();
				$('#modal-changePassword .recover-success-message').show();
				$('#modal-changePassword').attr('aria-hidden', 'false');
				
			}).fail(function(){
			$('#modal-changePassword .recover-success-message').hide();
			$('#modal-changePassword .recover-error-message').show();
			$('#modal-changePassword').attr('aria-hidden', 'false');
		});
	})
	
	
	if ($('#shopify-section-collection-template').length) {
		var sizesStr = '';
		
		$('[data-check-sizes]').each(function () {
			sizesStr += $(this).attr('data-check-sizes');
		});
		
		if (window.location.search.indexOf('size=') !== -1) {
			var sizeSelected = window.location.search.split('size=')[1];
			$('.CollectionMain').find('.ProductItem').parent().hide();
			$('.CollectionMain').find('.ProductItem[data-sizes*="*'+sizeSelected+'*"]').parent().show();
		}
		
		var sizesArr = sizesStr.split(',');
		function onlyUnique(value, index, self) {
			return self.indexOf(value) === index;
		}

		var uniqueSizes = sizesArr.filter( onlyUnique );
		var filtersSizes = [];
		$('.SizeSwatch__Radio.size-filter').each(function () {
			filtersSizes.push($(this).val());
		});
		
		//var array3 = uniqueSizes.filter(function(obj) { return filtersSizes.indexOf(obj) == -1; });
		var array4 = filtersSizes.sort((a, b) => a - b);
		$('.Collapsible__Content .SizeSwatchList').empty();
		array4.forEach(function (item, i) {
			if (item !== '') {
				var sizeItem = $('<li class="HorizontalList__Item">' +
					'                          <input id="option-collection-template-2-' + i +'" class="SizeSwatch__Radio size-filter" type="radio" name="option-size-collection-template"' + (sizeSelected == item ? ' checked="checked" ' : '') + 'value="'+ item+'">' +
					'                          <label for="option-collection-template-2-' + i +'" class="SizeSwatch">'+ item +'</label>' +
					'                        </li>');
				$('.Collapsible__Content .SizeSwatchList').append(sizeItem)
			}
		})
	}
	
	$('[href="#prevent"]').on('click', function (e) {
		e.preventDefault();
	})
	
	
	$('.ProductList .HorizontalList__Item label').on('click', function () {
		if ($(this).parent().hasClass('unavailable')) {
			var urlVariant = $(this).parent().find('input').data('variant-id');
			
			$(this).parents('.ProductItem__Info').find('.button-waitlist').attr('href', $(this).parents('.ProductItem__Info').find('.button-waitlist').data('origin-url') + '?variant=' + urlVariant ).show();
			$(this).parents('.ProductItem__Info').find('[data-action="quick-add-to-cart"]').hide();
		} else if (!$(this).parent().hasClass('unavailable') && $(this).parents('.ProductItem__Info').find('.button-waitlist').is(':visible') ) {
			$(this).parents('.ProductItem__Info').find('.button-waitlist').hide();
			$(this).parents('.ProductItem__Info').find('[data-action="quick-add-to-cart"]').show();
		}
	})
});
//*Logo change**/
$(document).ready(function(){
var initialSrc =$(".Header__FlexItem.Header__FlexItem--logo a.header_logo_link img.Header__LogoImage.custom_header_logs").attr('src');

var scrollSrc = $(".Header__FlexItem.Header__FlexItem--logo a.header_logo_link img.Header__LogoImage.custom_header_logs").attr('srcset');
$(window).scroll(function() {
   var value = $(this).scrollTop();
  
   if (value > 1)
      $(".Header__FlexItem.Header__FlexItem--logo a.header_logo_link img.Header__LogoImage.custom_header_logs").attr("srcset", initialSrc);
  
  else
      $(".Header__FlexItem.Header__FlexItem--logo a.header_logo_link img.Header__LogoImage.custom_header_logs").attr("srcset", scrollSrc);

});
  $(window).scroll(function() {
   var value = $(this).scrollTop();
  
   if (value > 1)
$(".custom_header_logo_m3").addClass("logo_add-remove");  
  else
$(".custom_header_logo_m3").removeClass("logo_add-remove");
});
  
  $('#shopify-section-header div#Search').mouseover(function () {
        $(".Header__FlexItem.Header__FlexItem--logo a.header_logo_link img.Header__LogoImage.custom_header_logs").attr("srcset", initialSrc);
    });
        $('#shopify-section-header div#Search').mouseout(function () {
        $(".Header__FlexItem.Header__FlexItem--logo a.header_logo_link img.Header__LogoImage.custom_header_logs").attr("srcset", scrollSrc);
    });
});
$(document).ready(function () {
$(".Product__Aside").removeClass("aside_option");
$(".size_chart").click(function(){
$(".Product__Aside").addClass("aside_option");
  });
});
